import { MODEL_IDS } from '@/dictionary/modelIds';

const track = {
  value: 'track',
  lang: {
    ru: 'цвет скрытия / Track',
    en: 'Mechanism hiding color / Track'
  }
};
const rail = {
  value: 'rail',
  lang: {
    ru: 'цвет профиля',
    en: 'Profile color'
  }
};
const ribs = {
  value: 'rail',
  lang: {
    ru: 'цвет профиля',
    en: 'Ribs Color'
  }
};
const chain = {
  value: 'chain',
  lang: {
    ru: 'цвет цепочки',
    en: 'chain color'
  }
};
const fixed = {
  value: 'fixed',
  lang: {
    ru: 'цвет крепления',
    en: 'Fixing details color'
  }
};

export const allTypes = [track, rail, chain, fixed];

export default {
  [MODEL_IDS.rollo]: [track, ribs, chain, fixed],
  [MODEL_IDS.flow]: [rail, fixed],
  [MODEL_IDS.panel]: [track, ribs, fixed],
  [MODEL_IDS.banner]: [ribs, fixed],
  [MODEL_IDS.slides]: [track, fixed],
  [MODEL_IDS.follo]: [ribs, chain, fixed]
};
